import React from 'react';
import { ListItem, UnorderedList, ListProps } from '@chakra-ui/react';

interface Props {
  items: string[];
}

export const StyledList = React.memo(
  ({ items, ...otherProps }: Props & ListProps) => {
    return (
      <UnorderedList listStyleType="none" {...otherProps}>
        {items.map((_, key) => (
          <ListItem
            color="gray.700"
            fontSize={{ base: 16, md: 18 }}
            key={key}
            pl={4}
            _before={{
              content: '" "',
              borderColor: 'transparent #fdc03b',
              borderStyle: 'solid',
              borderWidth: '.35em 0 .35em .45em',
              display: 'block',
              height: 0,
              width: 0,
              left: '-1em',
              top: '1.05em',
              position: 'relative',
            }}
          >
            {_}
          </ListItem>
        ))}
      </UnorderedList>
    );
  },
);
